import {keys} from "../config/nameSpacesKeys";
import GenericLangValue from "./GenericLangValue";
import {assetKeys} from "../config/constants";

export default class EnvironmentalImpactObj {
  constructor(name, initialValue, namespace) {
    this.namespace = namespace;
    this.name = name;
    this.measurementMethodology = new GenericLangValue(name = "measurementMethodology", null, keys.measurementMethodology);
    this.powerConsumption = new GenericLangValue(name = "powerConsumption", null, keys.powerConsumption);
    if (initialValue) {
      this.parseInputJSON(initialValue);
    }
  }

  getNameSpace() {
    return this.namespace;
  }

  getMeasurementMethodology() {
    return this.measurementMethodology;
  }

  setMeasurementMethodology(measurementMethodologyObj) {
    this.measurementMethodology = measurementMethodologyObj;
  }

  getPowerConsumption() {
    return this.powerConsumption;
  }

  setPowerConsumption(powerConsumptionObj) {
    this.powerConsumption = powerConsumptionObj;
  }

  parseInputJSON(inputJSON) {
    const obj=inputJSON;
    if (Array.isArray(obj)) {
      for (const entry of Object.entries(obj)) {
        const value=entry[1];
        this.parseObj(value);
      }
    } else {
      this.parseObj(obj);
    }
  }

  parseObj(obj) {
    this.measurementMethodology.parseInputJSON(obj);
    this.powerConsumption.parseInputJSON(obj);
  }

  getExpandedFormatValue() {
    const obj = {};
    obj[assetKeys.type] = [`${keys.environmentalImpactType}`];
    const measurementMethodologyExpanded = this.measurementMethodology.getExpandedFormatValue();
    const powerConsumptionExpanded = this.powerConsumption.getExpandedFormatValue();
    obj[this.measurementMethodology.getNameSpace()] = measurementMethodologyExpanded;
    obj[this.powerConsumption.getNameSpace()] = powerConsumptionExpanded;
    return obj;
  }

  isEmpty() {
    const condition1 = this.measurementMethodology.isEmpty();
    const condition2 = this.powerConsumption.isEmpty();
    return condition1 && condition2;
  }
}
